// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/async/" + (chunkId === "1036" ? "component-carousel" : chunkId) + "." + {"1036": "2d8a4471","8868": "b5c8821b","8976": "c5ff0607","9420": "c20c4cb6","9463": "da2b4dbb",}[chunkId] + ".js"
}